export default "__VITE_ASSET__HXeTCVqA__"